import React from "react";

export const FileEditContext = React.createContext();